<template>
  <div class="wrapper-login">
    <div class="wrapper-container">
      <div class="container">
        <img src="@/assets/logo/LogoYellow.svg" alt="" class="logo" />
        <img src="@/assets/icons/Android.svg" alt="" class="icon" />
        <a :href="route" class="wrapper-button">
          <LoginButton :buttonLabel="'Descarga nuestra app'" />
        </a>
      </div>
    </div>
    <div class="wrapper-image">
      <img src="@/assets/images/LoginImage.png" alt="" class="image" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LoginButton from "@/components/commons/controls/LoginButton.vue";
import { downloadUse } from "./use/downloadUse";

export default defineComponent({
  name: "DownloadView",
  components: {
    LoginButton,
  },

  setup() {
    const { route } = downloadUse();

    return {
      route,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/download/styles/downloadStyle";
</style>